/**
 * Base class for all preview enrichers.
 * Enrichers process rendered markdown to add interactivity and enhanced features.
 */

import type { EnricherConfig, EnricherContext } from './types.js';

export abstract class BaseEnricher {
  readonly config: EnricherConfig;
  readonly priority: number;
  readonly name: string;

  constructor(config: EnricherConfig = {}) {
    this.config = config;
    this.priority = config.priority ?? 0;
    this.name = this.constructor.name;
  }

  /**
   * Process the markdown output container.
   * Subclasses must implement this method.
   */
  abstract process(container: HTMLElement, context: EnricherContext): Promise<void>;

  /**
   * Check if this enricher should run.
   * Override to conditionally skip enrichment.
   */
  shouldRun(_context: EnricherContext): boolean {
    return true;
  }

  /**
   * Clean up resources when the enricher is removed or the page is unloaded.
   * Override to perform cleanup.
   */
  teardown(): void {}
}
